<template>
  <div id="app">

    <div>
      <navbar2 />
      <drawer />

<navbarboot />


      <router-view />

    </div>
  </div>
</template>











<script>
  import navbar2 from '@/layout/navbar2.vue';
  import drawer from '@/components/drawer/drawer.vue';
  import navbarboot from '@/layout/nav_bar_boot.vue';

  export default {
    name: "library",

    components: {
      navbar2,
      drawer,navbarboot
    },

    data() {
      return {
        items: [],
        shownav: true
      }
    },

    methods: {
      async accept() {
        this.showUpgradeUI = false
        await this.$workbox.messageSW({
          type: "SKIP_WAITING"
        });
      }


    },
    created() {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/service-worker.js").then(reg => {
            console.log("Registration succesful, scope: " + reg.scope);
          })
          .catch(err => {
            console.log(err);
          })
      }

      if (this.$workbox) {
        this.$workbox.addEventListener("waiting", () => {
          this.showUpdateUI = true;
        });
      }

    },
    computed: {


    },
    mounted() {
      this.$utils.check_token()

      /*if(this.$route.path.includes("panel")  ) {
          this.shownav=false
        } else {
          this.shownav=true
        }*/
    },



  };
</script>


<style>
  @import './assets/css/font.css';
  @import './assets/css/style.css';
  @import './assets/css/panel.css';
  @import './assets/css/inputs.css';

  @import './assets/css/swiper.css';

  * {

    padding: 0;
    margin: 0;
    border: 0;
  }

  body {
    direction: rtl;

    background-color: #f9fafb;
  }

  *,
  html {

    /* scroll-behavior: smooth !important;   */
    scroll-behavior: auto !important;
  }


  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }


  #app {
    font-family: IRANSans !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  .hide {
    display: none;
  }
</style>